/**
 * Converts a string to title case (e.g., "BIRTH" → "Birth", "death" → "Death")
 * @param {string} str - The string to convert
 * @returns {string} The title-cased string
 */
export const toTitleCase = (str) => {
  if (!str) return str
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}
